// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3xycR","scaleUp":"styles_scaleUp__2Q1fe","scaleDown":"styles_scaleDown__mlJ6B"};